import React from 'react';
import { CORPORATE_CHEVRONRIGHT, Icon } from '../../../icons';
export const NextPageLabel = ({ label }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null, label),
        React.createElement(Icon, { icon: CORPORATE_CHEVRONRIGHT })));
};
//# sourceMappingURL=next-page-label.js.map